import styles from "./Navbar.module.css";
import Button from "../Button/Button";
import Search from "../Search/Search";
import Logo from "../../assets/qtify_logo.png";

const Navbar = () => {
  return (
    <nav className={styles.navbar}>
      <div className={styles.Logodiv}>
        <img src={Logo} alt="Logo_Image" width={67} />
      </div>
      <Search />
      <a
        href="https://www.linkedin.com/in/kishan-ambaliya/"
        target="_blank"
        rel="noreferrer"
      >
        <Button text="Give Feedback" />
      </a>
    </nav>
  );
};

export default Navbar;